import React, { useState, useEffect } from 'react';
import {Form, Button, Card, Row, Col, ListGroup, Alert} from 'react-bootstrap';
import jsPDF from 'jspdf';
import emsLogo from '../img/ems.png';

const leaders = [
    '1357797105955242075',
    '1357797133100777643',
    '1357797196371595435',
    '1357797197697122465',
    '1357832069388177478'
];

const MemberCard = () => {
    const [records, setRecords] = useState([]);
    const [allMembers, setAllMembers] = useState([]);
    const [query, setQuery] = useState('');
    const [selected, setSelected] = useState(null);
    const [suggestions, setSuggestions] = useState([]);
    const [isAllowed, setIsAllowed] = useState(false);

    useEffect(() => {
        const raw = localStorage.getItem('ems_member');
        if (raw) {
            const parsed = JSON.parse(raw);
            const roles = parsed.user.roles;

            const isLeader = roles.some(role => leaders.includes(role));
            setIsAllowed(isLeader);

            if (isLeader) {
                fetch('https://ems.lexikonn.eu/api/get_records.php')
                    .then(res => res.json())
                    .then(data => {
                        setRecords(data);
                    });
            }
        }
    }, []);

    useEffect(() => {
        fetch('https://ems.lexikonn.eu/api/get_records.php')
            .then(res => res.json())
            .then(data => {
                setRecords(data);

                const membersFromMembers = data.flatMap(r =>
                    r.members?.split(',').map(m => m.trim()).filter(Boolean) || []
                );

                const membersFromUsers = data.map(r => r.user).filter(Boolean);

                const all = [...membersFromMembers, ...membersFromUsers];
                const unique = [...new Set(all)];
                setAllMembers(unique);
            });
    }, []);

    const getStats = (name) => {
        const now = new Date();
        const startOfWeek = new Date(now);
        startOfWeek.setDate(now.getDate() - now.getDay());
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        let total = 0, thisMonth = 0, thisWeek = 0;

        records.forEach(r => {
            const inMembers = r.members?.split(',').map(m => m.trim()).includes(name);
            const isUser = r.user === name;
            if (inMembers || isUser) {
                const dt = new Date(r.dt);
                total++;
                if (dt >= startOfMonth) thisMonth++;
                if (dt >= startOfWeek) thisWeek++;
            }
        });

        return { total, thisMonth, thisWeek };
    };

    const handleSuggestionClick = (name) => {
        setQuery(name);
        setSelected(name);
        setSuggestions([]);
    };

    const downloadPDF = () => {
        if (!selected) return;
        const stats = getStats(selected);
        const doc = new jsPDF();

        doc.addImage(emsLogo, 'PNG', 80, 10, 50, 50);
        const now = new Date().toLocaleString();
        const startY = 70;
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('Karta záchranare', 20, startY);

        doc.setFontSize(13);
        doc.setFont('helvetica', 'normal');
        doc.text(`Jmeno: ${selected}`, 20, startY + 10);
        doc.text(`Celkem vyjezdu: ${stats.total}`, 20, startY + 20);
        doc.text(`Tento mesic: ${stats.thisMonth}`, 20, startY + 30);
        doc.text(`Tento tyden: ${stats.thisWeek}`, 20, startY + 40);
        doc.text(`Zaznam k datu: ${now}`, 20, startY + 50);

        doc.save(`${selected.replaceAll(' ', '_')}_karta_zachranare.pdf`);
    };

    if (!isAllowed) {
        return <Alert variant="danger" className="m-5 text-center lead">Přístup pouze pro vedení EMS!</Alert>;
    }

    return (
        <div className="container py-5">
            <h2 className="mb-4">🚑 Karta záchranáře</h2>

            <Form className="mb-4" onSubmit={(e) => e.preventDefault()}>
                <Row>
                    <Col md={12} className="position-relative">
                        <Form.Control
                            type="text"
                            placeholder="Zadej jméno záchranáře"
                            value={query}
                            onChange={(e) => {
                                const value = e.target.value;
                                setQuery(value);
                                const filtered = allMembers.filter(m =>
                                    m.toLowerCase().includes(value.toLowerCase()) && value.length > 1
                                );
                                setSuggestions(filtered);
                            }}
                            autoComplete="off"
                        />
                        {suggestions.length > 0 && (
                            <ListGroup className="position-absolute w-100 z-3" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                {suggestions.map((s, i) => (
                                    <ListGroup.Item key={i} action onClick={() => handleSuggestionClick(s)}>
                                        {s}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                    </Col>
                </Row>
            </Form>

            {selected && (
                <Card className="mb-4 shadow">
                    <Card.Body>
                        <h4>{selected}</h4>

                        <h5 className="mt-4">📊 Statistiky</h5>
                        <Button variant="outline-danger" size="sm" onClick={downloadPDF} className="mb-3">
                            📄 Stáhnout PDF
                        </Button>

                        <ul>
                            {(() => {
                                const { total, thisMonth, thisWeek } = getStats(selected);
                                return (
                                    <>
                                        <li>Celkem výjezdů: <b>{total}</b></li>
                                        <li>Tento měsíc: <b>{thisMonth}</b></li>
                                        <li>Tento týden: <b>{thisWeek}</b></li>
                                    </>
                                );
                            })()}
                        </ul>
                    </Card.Body>
                </Card>
            )}
        </div>
    );
};

export default MemberCard;
